import { Link } from 'react-router-dom';
import { themeClasses } from '@member-portal/ui';

interface PartnerPageHeroProps {
  ctaLabel?: string;
  ctaHref?: string;
  onCtaClick?: (e: React.MouseEvent) => void;
}

function PartnerPageHero({
  ctaLabel = 'Partner Opportunities',
  ctaHref,
  onCtaClick,
}: PartnerPageHeroProps) {
  const ctaClassName = `inline-block px-8 py-4 bg-white ${themeClasses.text.button} text-black hover:bg-white/90 transition-colors duration-300 uppercase`;

  return (
    <section className="relative py-32 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: 'url(/images/images/pauline-bernard-jEERev5W93s-unsplash.jpg)' }}
      />
      <div className="absolute inset-0 bg-black/50" />
      <div className={`relative z-10 ${themeClasses.container}`}>
        <div className="max-w-4xl mx-auto text-center">
          <p className={`${themeClasses.text.muted} text-sm uppercase tracking-widest mb-6 text-white/80`}>
            A MARKETING DIVISION OF FOUR HUNDRED
          </p>
          <h1 className={`${themeClasses.title.h1} mb-6 text-white`}>
            Partner with Four Hundred by Design
          </h1>
          <p className={`${themeClasses.text.body} text-lg max-w-3xl mx-auto mb-10 text-white/90`}>
            Reach a new audience of travel advisors and an influential member-based community
          </p>
          {ctaHref ? (
            <Link to={ctaHref} className={ctaClassName}>
              {ctaLabel}
            </Link>
          ) : (
            <a href="#partner-inquiry" onClick={onCtaClick} className={ctaClassName}>
              {ctaLabel}
            </a>
          )}
        </div>
      </div>
    </section>
  );
}

export default PartnerPageHero;
